import { defineMessages } from 'react-intl';

const scope = 'app.containers.admin.AccountManagement.PropertyDetails';

export default defineMessages({
    title: {
        id: `${scope}.title`,
        defaultMessage: 'Property Details',
    },
    name: {
        id: `${scope}.name`,
        defaultMessage: 'Property',
    },
    groupName: {
        id: `${scope}.groupName`,
        defaultMessage: 'Group',
    },
    forecastType: {
        id: `${scope}.forecastType`,
        defaultMessage: 'Forecast Type',
    },
    pms: {
        id: `${scope}.pms`,
        defaultMessage: 'PMS',
    },
    rateCode: {
        id: `${scope}.rateCode`,
        defaultMessage: 'Rate plan Code',
    },
    personaParent: {
        id: `${scope}.personaParent`,
        defaultMessage: 'Persona Parent',
    },
    cardinalRecommendations: {
        id: `${scope}.cardinalRecommendations`,
        defaultMessage: 'Cardinal Recs',
    },
    aeRecommendations: {
        id: `${scope}.aeRecommendations`,
        defaultMessage: 'AE Recs',
    },
    cardinalSend2Way: {
        id: `${scope}.cardinalSend2Way`,
        defaultMessage: 'Cardinal Send 2 way',
    },
    forecastGeneration: {
        id: `${scope}.forecastGeneration`,
        defaultMessage: 'Forecast Generation',
    },
    otaManagedBy: {
        id: `${scope}.otaManagedBy`,
        defaultMessage: 'OTA Manager',
    },
    otaDemand: {
        id: `${scope}.otaDemand`,
        defaultMessage: 'OTA Demand',
    },
    otaParity: {
        id: `${scope}.otaParity`,
        defaultMessage: 'OTA Parity',
    },
    otaRates: {
        id: `${scope}.otaRates`,
        defaultMessage: 'OTA Rates',
    },
    guestRevu: {
        id: `${scope}.guestRevu`,
        defaultMessage: 'Guestrevu',
    },
    recommendationSchedule: {
        id: `${scope}.recommendationSchedule`,
        defaultMessage: 'Rec Schedule',
    },
    forecastSchedule: {
        id: `${scope}.forecastSchedule`,
        defaultMessage: 'Forecast Schedule',
    },
    groupBlocks: {
        id: `${scope}.groupBlocks`,
        defaultMessage: 'Group Blocks',
    },
});
